<template>
  <mds-list-group>
    <mds-list-group-item
      class="general-tab__title"
      text="Name"
      :microcopy="name"
    >
    </mds-list-group-item>
    <mds-list-group-item
      class="general-tab__title"
      v-for="(item, key) in arrayItems"
      :key="key"
      :text="getCapTitle(item[0])"
      :microcopy="getPropValue(item[0], item[1])"
    >
    </mds-list-group-item>
  </mds-list-group>
</template>

<script>
import { MdsListGroup, MdsListGroupItem } from '@mds/list-group'
import {
  FEED_INVESTMENTS_METADATA,
  FEED_PERFORMANCE_REPORTS_METADATA,
  PARAMETER_FEED_NAMES,
  PARAMETER_SCHEDULE_NAMES,
  PERFORMANCE_REPORT,
  DELIVERY_DESTINATION,
  DELIVERY_TYPE,
  DELIVERY_TYPE_EMAIL,
  VIEWS,
} from '../config/constants'
import { NOTEBOOK_PARAMETER_NAMES } from '../../schedulerModal/config/constants'

export default {
  name: 'GeneralTab',
  components: {
    MdsListGroup,
    MdsListGroupItem,
  },
  props: {
    parameters: {
      type: Object,
      default: () => ({}),
    },
    displayItems: {
      type: Array,
      default: () => [],
    },
    view: {
      type: String,
      default: '',
    },
    name: {
      type: String,
    },
  },
  computed: {
    feedDetails() {
      let metadataType = []
      if (this.parameters && this.parameters.investment_object_type) {
        metadataType =
          this.parameters.investment_object_type.toLowerCase() ===
          PERFORMANCE_REPORT
            ? FEED_PERFORMANCE_REPORTS_METADATA
            : FEED_INVESTMENTS_METADATA
      }
      return Object.entries(this.parameters).reduce((acc, [key, value]) => {
        if (metadataType.includes(key)) {
          const key_value = PARAMETER_FEED_NAMES.includes(key)
            ? this.formatItem(key)
            : value.toString()
          return {
            ...acc,
            [key]: key_value.toString(),
          }
        }
        return acc
      }, {})
    },
    scheduleDetails() {
      return Object.entries(this.parameters).reduce((acc, [key, value]) => {
        if (Object.keys(PARAMETER_SCHEDULE_NAMES).includes(key)) {
          const key_value = this.getItemValue(key, value)
          return {
            ...acc,
            [PARAMETER_SCHEDULE_NAMES[key]]: key_value.toString(),
          }
        }
        return acc
      }, {})
    },
    arrayItems() {
      return this.view === VIEWS.feeds
        ? Object.entries(this.feedDetails)
        : Object.entries(this.scheduleDetails)
    },
  },
  methods: {
    getCapTitle(string) {
      return string
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    },
    getPropValue(key, value) {
      if (key === NOTEBOOK_PARAMETER_NAMES.data_set && value === '') {
        return 'Untitled'
      }

      return value
    },
    formatItem(key) {
      // Set current parameter value to use it for default cases or Email type case
      let formattedParameter = this.parameters[key]

      // Get notebook type by key
      const item = this.displayItems.length
        ? this.displayItems.find(
            (item) => item.name.toLowerCase() === key.toLowerCase()
          )
        : null

      if (item && item.options.length && item.options[0]) {
        // Get option object by id to display it in the Flyover General tab
        const option = item.options.find(
          ({ id }) =>
            id.toString().toLowerCase() ===
            formattedParameter.toString().toLowerCase()
        )

        formattedParameter = option && option.name ? option.name : ''

        if (key.toLowerCase() === DELIVERY_DESTINATION) {
          formattedParameter =
            this.parameters[DELIVERY_TYPE].toLowerCase() === DELIVERY_TYPE_EMAIL
              ? this.parameters[key]
              : this.getFPTText(option)
        }
      }
      return formattedParameter
    },
    getItemValue(key, value) {
      switch (key.toLowerCase()) {
        case 'frequency':
          return value.repeatType
        case 'runningtime': {
          const { time, timezone, utcOffset } = this.parameters.nextRun
          return time ? `${time} ${timezone} (${utcOffset})` : '—'
        }
        default:
          return value
      }
    },
    getFPTText(route) {
      return route.folder !== '/'
        ? `${route.server}/${route.folder}`
        : `${route.server}/`
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.general-tab {
  &__title {
    margin-bottom: $mds-space-half-x;
    &::v-deep [class^='mds-list-group-item__text'] {
      @include mds-body-text-s();
      color: $mds-text-color-secondary;
    }
    &::v-deep [class^='mds-list-group-item__microcopy'] {
      @include mds-body-text-s();
      color: $mds-text-color-primary;
      word-wrap: break-word;
    }
  }
}
</style>
